/*
 *
 * ReceptionDxGrid14852
 *
 */

import {ReceptionDxGrid} from 'pages/Requests/ReceptionView';
import {
    ACTIVE_REQUESTS,
    CURRENT_DAY_REQUESTS, ON_CREATE_REQUESTS, REQUESTS_FOR_MAKING_AGREEMENT_BC, REQUESTS_FOR_ON_PASS,
    REQUESTS_ON_CAR_ENTRY, REQUESTS_ON_PROPERTY_BRINGING, REQUESTS_ON_PROPERTY_REMOVED,
    REQUESTS_ON_VISIT, REQUESTS_ON_WORK_PRODUCTION
} from "domain/Data/Filters/constants";


export class ReceptionDxGrid14852 extends ReceptionDxGrid {

    getFilters() {
        const { viewName } = this.props;
        const filters = [];
        if (viewName === 'active') filters.push(ACTIVE_REQUESTS);
        if (viewName === 'today') filters.push(CURRENT_DAY_REQUESTS);
        if (viewName === 'onVisit') filters.push(REQUESTS_ON_VISIT);
        if (viewName === 'onCarEntry') filters.push(REQUESTS_ON_CAR_ENTRY);
        if (viewName === 'pass') filters.push(REQUESTS_FOR_ON_PASS);
        if (viewName === 'create') filters.push(ON_CREATE_REQUESTS);
        if (viewName === 'agree') filters.push(REQUESTS_FOR_MAKING_AGREEMENT_BC);
        if (viewName === 'propertyBringing') filters.push(REQUESTS_ON_PROPERTY_BRINGING);
        if (viewName === 'propertyRemoved') filters.push(REQUESTS_ON_PROPERTY_REMOVED);
        if (viewName === 'carryingOutWorks') filters.push(REQUESTS_ON_WORK_PRODUCTION);
        return filters
    }

    getColumns() {
        const columns = super.getColumns();

        columns.push({
            path: ['department', 'name'],
            name: 'department',
            title: 'Здание',
            getCellValue: (row) => row.department ? row.department.name : undefined,
            width: 150,
        });

        return columns;
    }

    getColumnOrder() {
        const columnOrder = super.getColumnOrder();

        const companyNameIndex = columnOrder.findIndex(columnName => columnName === 'company_name')
        columnOrder.splice(companyNameIndex + 1, 0, 'department');

        return columnOrder;
    }

}
